import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/**
 * A keyboard key. Only render one where the shortcut actually works.
 * `onColor` is the translucent variant for inside a coloured button.
 * `rounded-sm` (4px) is outside the control/card/pill scale on purpose: an 8px
 * radius on an 18px-high key turns it into a pill.
 */
export function Kbd({ children, onColor }: { children: ReactNode; onColor?: boolean }) {
  return (
    <kbd
      data-slot="kbd"
      data-on-color={onColor ? '' : undefined}
      className={cn(
        'rounded-sm border border-b-2 px-1.5 py-0.5 font-mono text-2xs font-medium leading-none',
        onColor ? 'border-black/25 bg-black/15 text-current' : 'border-line-strong bg-surface-hover text-ink',
      )}
    >
      {children}
    </kbd>
  );
}
